import { render } from "./MfittMyTicketChange.vue?vue&type=template&id=30650594"
import script from "./MfittMyTicketChange.vue?vue&type=script&lang=js"
export * from "./MfittMyTicketChange.vue?vue&type=script&lang=js"
script.render = render

export default script